const localMarketingImg = document.querySelector("#localMarketingImg");
const localMarketingList = document.querySelectorAll("#localMarketingList .local-marketing__item");
const localMarketingImgDesc = document.querySelector("#localMarketingImgDesc");

localMarketingList?.forEach((item) => {
  item.addEventListener("mouseover", () => {
    if (localMarketingImg.alt != item.dataset.city) {
      localMarketingImgDesc.textContent = item.dataset.city;
      localMarketingImg.src = item.dataset.img;
      localMarketingImg.alt = item.dataset.city;
      localMarketingImg.classList.remove("animation-opacity");
      void localMarketingImg.offsetWidth;
      localMarketingImg.classList.add("animation-opacity");
    }
  });
});
